// extracted by mini-css-extract-plugin
export default {"container":"Go-z","ratingLayout":"Ho-z","ratingLabel":"Io-z","nonInteractiveRatingLabel":"Jo-z"};